/// <amd-module name="SuiteCommerce.ItemRecSys.Instrumentation.Logger" />
define("SuiteCommerce.ItemRecSys.Instrumentation.Logger", ["require", "exports", "jQuery", "SuiteCommerce.ItemRecSys.Common.Helper"], function (require, exports, jQuery, Helper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Logger = void 0;
    var Logger = /** @class */ (function () {
        function Logger() {
            var _this = this;
            this.endpointUrl = (0, Helper_1.getSuiteletUrl)(Logger.ELOGGER_ENDPOINT_SCRIPT, Logger.ELOGGER_ENDPOINT_DEPLOY);
            this.queueErrorTemp = [];
            this.queueInfoTemp = [];
            this.isWaiting = false;
            if (!Logger.isEnabled()) {
                return;
            }
            setInterval(function () {
                _this.processQueues(true);
            }, 20000);
            window.addEventListener('beforeunload', function () {
                _this.processQueues(false);
            });
        }
        Logger.initializeEnvironment = function (container) {
            Logger.environment = container.getComponent('Environment');
        };
        ;
        Logger.get = function () {
            Logger.instance = Logger.instance || new Logger();
            return this.instance;
        };
        Logger.isEnabled = function () {
            return !Logger.environment.isPageGenerator();
        };
        Logger.prototype.info = function (obj) {
            this.log(obj, this.queueInfoTemp, Logger.QUEUE_INFO_NAME);
        };
        Logger.prototype.error = function (obj) {
            this.log(obj, this.queueErrorTemp, Logger.QUEUE_ERROR_NAME);
        };
        Logger.prototype.log = function (logObj, tempQueue, queueName) {
            if (!Logger.isEnabled()) {
                return;
            }
            var currentTimeMillis = Date.now();
            var queue = JSON.parse(localStorage.getItem(queueName)) || [];
            var duplicate = queue.concat(tempQueue).some(function (queuedLog) {
                return queuedLog.subType === logObj.subType &&
                    queuedLog.widgetUuid === logObj.widgetUuid &&
                    Math.abs(currentTimeMillis - queuedLog.clientSideMillis) < Logger.DUPLICATE_LOG_MAX_MILLIS;
            });
            if (duplicate) {
                // console.debug("DUP LOG", logObj);
                return;
            }
            logObj.suiteScriptAppVersion = SC.ENVIRONMENT.RELEASE_METADATA.version;
            logObj.clientSideMillis = currentTimeMillis;
            logObj.clientSideLogDateTime = (new Date(currentTimeMillis)).toISOString();
            if (this.isWaiting) {
                tempQueue.push(logObj);
            }
            else {
                queue.push(logObj);
                localStorage.setItem(queueName, JSON.stringify(queue));
            }
        };
        Logger.prototype.processQueues = function (isAsync) {
            if (!Logger.isEnabled()) {
                return;
            }
            var queueError = JSON.parse(localStorage.getItem(Logger.QUEUE_ERROR_NAME));
            var queueInfo = JSON.parse(localStorage.getItem(Logger.QUEUE_INFO_NAME));
            if ((queueInfo && queueInfo.length > 0) || (queueError && queueError.length > 0)) {
                this.isWaiting = true;
                var data = { info: queueInfo, error: queueError };
                this.sendDataThroughAjaxRequest(this.endpointUrl, data, isAsync);
            }
        };
        Logger.prototype.sendDataThroughAjaxRequest = function (url, data, isAsync) {
            var _this = this;
            jQuery.ajax({
                url: url,
                data: JSON.stringify(data),
                type: 'POST',
                async: isAsync,
            }).done(function () { return _this.clearQueues(); })
                .fail(function () { return _this.appendTemp(); });
        };
        Logger.prototype.clearQueues = function () {
            localStorage.setItem(Logger.QUEUE_ERROR_NAME, JSON.stringify(this.queueErrorTemp));
            localStorage.setItem(Logger.QUEUE_INFO_NAME, JSON.stringify(this.queueInfoTemp));
            this.queueErrorTemp = [];
            this.queueInfoTemp = [];
            this.isWaiting = false;
        };
        Logger.prototype.appendTemp = function () {
            var queueErrorStr = localStorage.getItem(Logger.QUEUE_ERROR_NAME);
            var queueInfoStr = localStorage.getItem(Logger.QUEUE_INFO_NAME);
            if (this.queueErrorTemp.length > 0) {
                var queueError = queueErrorStr == null ? [] : JSON.parse(queueErrorStr);
                localStorage.setItem(Logger.QUEUE_ERROR_NAME, JSON.stringify(queueError.concat(this.queueErrorTemp)));
            }
            if (this.queueInfoTemp.length > 0) {
                var queueInfo = queueInfoStr == null ? [] : JSON.parse(queueInfoStr);
                localStorage.setItem(Logger.QUEUE_INFO_NAME, JSON.stringify(queueInfo.concat(this.queueInfoTemp)));
            }
            this.isWaiting = false;
        };
        Logger.ELOGGER_ENDPOINT_SCRIPT = 'customscript_ns_recsys_wgt_logger';
        Logger.ELOGGER_ENDPOINT_DEPLOY = 'customdeploy_ns_recsys_wgt_logger';
        Logger.QUEUE_NAME_SUFFIX = '-RecSysWidget';
        Logger.QUEUE_ERROR_NAME = "queueError".concat(Logger.QUEUE_NAME_SUFFIX);
        Logger.QUEUE_INFO_NAME = "queueInfo".concat(Logger.QUEUE_NAME_SUFFIX);
        Logger.DUPLICATE_LOG_MAX_MILLIS = 500;
        Logger.environment = null;
        return Logger;
    }());
    exports.Logger = Logger;
});
